import { ExpressionType } from '../../IExpression';

import { IConditionExpression } from '../condition/IConditionExpression';
import { IFunctionExpression } from '../function/IFunctionExpression';

export interface IConditionGroupExpression {
  /** conditionGroup */
  type: ExpressionType.ConditionGroup;
  /** Operatore su un insieme di espressioni booleane di confronto (condizioni) */
  operator: ConditionGroupOperator;
  conditions: IConditionItem[];
}

export type IConditionItem =
  | IConditionExpression
  | IConditionGroupExpression
  | IFunctionExpression;

// TODO: Supportare anche il not
export enum ConditionGroupOperator {
  And = 'and',
  Or = 'or',
}
